import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource);

const auth = {
    status: Vue.resource('/api/auth'),
    login: Vue.resource('/api/auth/login'),
    logout: Vue.resource('/api/auth/logout'),
    refresh: Vue.resource('/api/auth/refresh'),
    password_restore: Vue.resource('/api/auth/password-reset-request'),
    password_reset: Vue.resource('/api/auth/password-reset'),
    verify_email: Vue.resource('/api/auth/verify-email{/token}'),
    oAuthProviders: Vue.resource('/api/auth/providers')
}
const api = {
    users: Vue.resource('/api/users'),
    users_params: Vue.resource('/api/users{/id}'),
    user_settings: Vue.resource('/api/user-settings{/id}'),
    user_notifications: Vue.resource('/api/user-notifications{/id}'),
    send_confirm_email: Vue.resource('/api/users/email-confirmation{/id}'),
    lock_settings: Vue.resource('/api/users/lock'),
    unlock_settings: Vue.resource('/api/users/unlock'),
    reset_pin: Vue.resource('/api/users/pin-reset'),
    connect_social_acc: Vue.resource('/api/auth/oauth-connect'),
    disconnect_social_acc: Vue.resource('/api/auth/oauth-disconnect'),

    sessions: Vue.resource('/api/sessions{/id}'),

    constants_enums: Vue.resource('/api/enums'),
    currencies: Vue.resource('/api/currencies'),
    exchange: Vue.resource('/api/currencies/exchange'),
    countries: Vue.resource('/api/user-settings/countries'),
    cities: Vue.resource('/api/user-settings/cities{/country_code}'),

    spaces: Vue.resource('/api/spaces{/id}'),
    space_members: Vue.resource('/api/spaces/members{/space_id}'),
    space_unlink_user: Vue.resource('/api/spaces/unlink-user{/user_id}'),
    space_update_user_role: Vue.resource('/api/spaces/update-user-role{/user_id}'),
    space_api_token: Vue.resource('/api/users/api-token{/id}'),

    space_export_file: Vue.resource('/api/spaces/export{/id}'),
    space_import: Vue.resource('/api/spaces/import'),
    space_leave: Vue.resource('/api/spaces/leave{/id}'),

    invitations: Vue.resource('/api/invitations{/id}'),
    invitations_sent: Vue.resource('/api/invitations/sent{/space_id}'),
    invitations_resend: Vue.resource('/api/invitations/resend'),
    accept_invite: Vue.resource('/api/invitations/accept'),
    decline_invite: Vue.resource('/api/invitations/decline'),
    connect_invite_token: Vue.resource('/api/invitations{/token}'),

    accounts: Vue.resource('/api/accounts{/id}'),
    accountsUpdateOrder: Vue.resource('/api/accounts/update-order'),
    account_groups: Vue.resource('/api/account-groups{/id}'),
    accountGroupsUpdateOrder: Vue.resource('/api/account-groups/update-order'),

    incomes: Vue.resource('/api/income-sources{/id}'),
    incomesUpdateOrder: Vue.resource('/api/income-sources/update-order'),

    expenses: Vue.resource('/api/expense-categories{/id}'),
    expense_groups: Vue.resource('/api/expense-category-groups{/id}'),
    expensesUpdateOrder: Vue.resource('/api/expense-category/update-order'),
    expenseGroupsUpdateOrder: Vue.resource('/api/expense-category-groups/update-order'),

    transactions: Vue.resource('/api/transactions'),
    transactions_id: Vue.resource('/api/transactions{/id}'),
    transaction_to_transfer: Vue.resource('/api/transactions/to-transfer{/id}'),

    budget_create: Vue.resource('/api/budgets/batch-create'),
    budget_copy: Vue.resource('/api/budgets/copy'),
    budgets: Vue.resource('/api/budgets{/id}'),
    budgets_widget: Vue.resource('/api/budgets/widget-summary'),

    transfers: Vue.resource('/api/transfers'),
    transfers_id: Vue.resource('/api/transfers{/id}'),
    tags: Vue.resource('/api/tags{/id}'),
    tags_id: Vue.resource('/api/tags{/id}'),
    contractors: Vue.resource('/api/contractors'),
    contractors_id: Vue.resource('/api/contractors{/id}'),

    report_income: Vue.resource('/api/reports/income'),
    report_expense: Vue.resource('/api/reports/expense'),

    faqs: Vue.resource('/api/faqs'),
    goals: Vue.resource('/api/goals{/id}'),
    goal_replenish_balance: Vue.resource('/api/goals/replenish/{goal_id}'),
    goals_chart_data: Vue.resource('/api/goals/chart/{goal_id}'),

    goal_close: Vue.resource('/api/goals/close{/id}'),
    goals_covers: Vue.resource('/api/goals/covers{/space_id}'),
    goals_upload_image: Vue.resource('/api/goals/upload-cover'),
}
const banks_api = {
    banksList: Vue.resource('/api/banks/list'),
    connectBank: Vue.resource('/api/banks/connect'),
    disconnectBank: Vue.resource('/api/banks/disconnect'),
    banksConnections: Vue.resource('/api/banks/connections'),
    banksAccounts: Vue.resource('/api/banks/accounts'),
    connectAccounts: Vue.resource('/api/banks/connect-accounts'),
    refreshBankConnection: Vue.resource('/api/banks/refresh'),
}
const investments_api = {
    portfolios: Vue.resource('/api/invest-portfolios{/id}'),
    portfolio_dynamics: Vue.resource('/api/invest-portfolios/dynamics{/id}'),
    upload_portfolio_report: Vue.resource('/api/invest-portfolios/upload'),
    import_portfolio: Vue.resource('/api/invest-portfolios/import'),
    search_instrument: Vue.resource('/api/invest-instruments'),
    add_search_instrument: Vue.resource('/api/invest-instrument/add'),
    deals: Vue.resource('/api/invest-deals{/id}'),
    import_deals: Vue.resource('/api/invest-deals'),
    assets: Vue.resource('/api/invest-assets'),
    assets_grouped: Vue.resource('/api/invest-assets/grouped'),
    invest_brokers: Vue.resource('/api/invest-brokers'),
    purge_portfolio: Vue.resource('/api/invest-portfolios/purge'),
}
const tickets = {
    tickets: Vue.resource('/api/tickets{/id}'),
    reply: Vue.resource('/api/tickets/reply{/id}'),
    close: Vue.resource('/api/tickets/close{/id}'),
}
const trash = {
    fetchSummary: Vue.resource('/api/trash/{space_id}'),
    trashList: Vue.resource('/api/trash/{trashItem}/{space_id}'),
    restoreTrashItem: Vue.resource('/api/trash/restore'),
}

const calendar_api = {
    fetchMonth: Vue.resource('/api/calendars'),
    calendarTemplates: Vue.resource('/api/calendar-templates{/id}'),
    plannedTransactions: Vue.resource('/api/calendars/events{/id}'),
    confirmPlannedTransaction: Vue.resource('/api/calendars/confirm{/id}')
}

export {api, auth, investments_api, tickets, banks_api, trash, calendar_api};

